import i18n from "../../../i18n"

export const professors =
{
    department: i18n.t("msa_department"),
    professors:
        [
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1502/4499-Georgios_Vranos_1-2.png',
                fname: i18n.t('georgios'),
                lname: i18n.t('vranos'),
                title: i18n.t('proedrosTmimatos'),
                tel: '2310 891.490',
                email: 'gvranos@uom.edu.gr',
                building: 'ΚΖ',
                office: '431'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1498/4898-vasiliadis-2.jpg',
                fname: i18n.t('anastasios'),
                lname: i18n.t('vasileiadis'),
                title: i18n.t('kathigitis'),
                tel: '2310 891.528',
                email: 'anbasil@uom.edu.gr',
                building: '',
                office: 'Αίθουσα Κρουστών'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1485/7309-zervasnew-2.jpg',
                fname: i18n.t('thanasis'),
                lname: i18n.t('zervas'),
                title: i18n.t('kathigitis'),
                tel: '2310 891.329',
                email: 'a-zervas@uom.edu.gr',
                building: 'ΚΖ',
                office: '409'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1491/2219-kyriakakis_1-2.jpg',
                fname: i18n.t('georgios'),
                lname: i18n.t('kiriakakis'),
                title: i18n.t('kathigitis'),
                tel: '2310 891.346',
                email: 'gkyriakakis@uom.edu.gr',
                building: 'ΚΖ',
                office: '402'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1482/3195-Matske-2.jpg',
                fname: i18n.t('hans_ouve'),
                lname: i18n.t('papamatthaiou_matske'),
                title: i18n.t('kathigitis'),
                tel: '2310 891.396',
                email: 'um@uom.edu.gr',
                building: 'ΚΖ4',
                office: '400'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1481/5141-paris-2.jpg',
                fname: i18n.t('kiriakos_nektarios'),
                lname: i18n.t('paris'),
                title: i18n.t('kathigitis'),
                tel: '2310 891.345',
                email: 'nepa@uom.edu.gr',
                building: 'ΚΖ',
                office: '409'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1486/5972-PatrasPhoto-2.jpg',
                fname: i18n.t('dimitrios'),
                lname: i18n.t('patras'),
                title: i18n.t('kathigitis'),
                tel: '2310 891.395',
                email: 'dpatras@uom.edu.gr',
                building: 'ΚΖ4',
                office: '408'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1506/1839-politis340-2.jpg',
                fname: i18n.t('eugenios'),
                lname: i18n.t('politis'),
                title: i18n.t('kathigitis'),
                tel: '2310 891.400',
                email: 'politise@uom.edu.gr',
                building: 'ΚΖ4',
                office: '407'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1484/3526-stamoufoto-2.png',
                fname: i18n.t('lelouda'),
                lname: i18n.t('stamou'),
                title: i18n.t('kathigitria'),
                tel: '2310 891.391',
                email: 'lstamou@uom.edu.gr',
                building: 'Κ',
                office: '121'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1489/2245-ZenzPhoto-2.jpg',
                fname: i18n.t('katrin_annete'),
                lname: i18n.t('tsents'),
                title: i18n.t('kathigitria'),
                tel: '2310 891.125',
                email: 'katze@uom.edu.gr',
                building: 'ΚΖ4',
                office: '403'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1488/1681-dchand-2.jpg',
                fname: i18n.t('dimitrios'),
                lname: i18n.t('handrakis'),
                title: i18n.t('kathigitis'),
                tel: '2310 891.394',
                email: 'dchand@uom.edu.gr',
                building: 'ΚΖ4',
                office: '406'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1483/1737-khass-2.jpg',
                fname: i18n.t('konstantinos'),
                lname: i18n.t('hasiotis'),
                title: i18n.t('kathigitis'),
                tel: '2310 891.392',
                email: 'khass@uom.edu.gr',
                building: 'ΚΖ4',
                office: '403'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1493/2513-AtzakasThEd-2.jpg',
                fname: i18n.t('euthimios'),
                lname: i18n.t('atzakas'),
                title: i18n.t('anaplirotisKathigitis'),
                tel: '2310 891.328',
                email: 'atzakas@uom.edu.gr',
                building: 'ΚΖ',
                office: '411'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1499/5261-AchalinPhoto-2.jpg',
                fname: i18n.t('germanos'),
                lname: i18n.t('ahalinotopoulos'),
                title: i18n.t('anaplirotisKathigitis'),
                tel: '2310 891.324',
                email: 'achalin@uom.edu.gr',
                building: 'ΚΖ',
                office: '411'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1497/2467-PV_portrait-2.png',
                fname: i18n.t('petros'),
                lname: i18n.t('vouvaris'),
                title: i18n.t('anaplirotisKathigitis'),
                tel: '2310 891.729',
                email: 'vouvaris@uom.edu.gr',
                building: 'ΓΔ',
                office: '303'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1504/2482-Angelica_Cathariou_photo_1-2.jpg',
                fname: i18n.t('aggeliki'),
                lname: i18n.t('kathariou'),
                title: i18n.t('Αναπληρώτρια Καθηγήτρια'),
                tel: '2310 891.330',
                email: 'acathariou@uom.edu.gr',
                building: 'ΚΖ',
                office: '401'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1494/9903-Mumulides-2.jpg',
                fname: i18n.t('miltiadis'),
                lname: i18n.t('moumoulidis'),
                title: i18n.t('anaplirotisKathigitis'),
                tel: '2310 891.940',
                email: 'mmumulides@uom.edu.gr',
                building: 'ΚΖ4',
                office: '401'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1495/1602-papandreouE-2.jpg',
                fname: i18n.t('elena'),
                lname: i18n.t('papandreou'),
                title: i18n.t('Αναπληρώτρια Καθηγήτρια'),
                tel: '2310 891.401',
                email: 'papandre@uom.edu.gr',
                building: 'ΚΖ',
                office: '405'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1492/5885-PetrinPhoto-2.jpg',
                fname: i18n.t('igor'),
                lname: i18n.t('petrin'),
                title: i18n.t('anaplirotisKathigitis'),
                tel: '2310 891.532',
                email: 'ipetrin@uom.edu.gr',
                building: '',
                office: 'Ισόγειο, απέναντι Αμφιθεάτρου Τελετών'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1490/1174-arentzep-2.jpg',
                fname: i18n.t('anna_maria'),
                lname: i18n.t('rentzeperi'),
                title: i18n.t('Αναπληρώτρια Καθηγήτρια'),
                tel: '2310 891.522',
                email: 'arentzep@uom.edu.gr',
                building: 'Κ',
                office: '123'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1500/4767-sinop-2.jpg',
                fname: i18n.t('sokratis'),
                lname: i18n.t('sinopoulos'),
                title: i18n.t('anaplirotisKathigitis'),
                tel: '2310 891.397',
                email: 'sinopoul@uom.edu.gr',
                building: 'ΚΖ',
                office: '411'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1582/3124-zarias-2.jpg',
                fname: i18n.t('ioannis'),
                lname: i18n.t('zarias'),
                title: i18n.t('epikourosKathigitis'),
                tel: '2310 891.397',
                email: 'gzarias@uom.edu.gr',
                building: 'ΚΖ',
                office: '411'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1505/7182-sgouras-2.jpg',
                fname: i18n.t('ioannis'),
                lname: i18n.t('zgouras'),
                title: i18n.t('epikourosKathigitis'),
                tel: '2310 891.397',
                email: 'isgouras@uom.edu.gr',
                building: 'ΚΖ',
                office: '412'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1501/5235-kallimopoulou-2.jpg',
                fname: i18n.t('eleni'),
                lname: i18n.t('kallimopoulou'),
                title: i18n.t('epikouriKathigitria'),
                tel: '2310 891.769',
                email: 'elkalim@uom.edu.gr',
                building: 'ΓΔ',
                office: '303'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1579/3005-MELIGOPOULOU_1-2.jpg',
                fname: i18n.t('maria_emma'),
                lname: i18n.t('meligkopoulou'),
                title: i18n.t('epikouriKathigitria'),
                tel: '2310 891.410',
                email: 'mariamelig@uom.edu.gr',
                building: '',
                office: 'Ημιώροφος, Εξώστης Αμφιθεάτρου Τελετών'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1500/4767-sinop-2.jpg',
                fname: i18n.t('konstantinos'),
                lname: i18n.t('raptis'),
                title: i18n.t('epikourosKathigitis'),
                tel: '2310 891.941',
                email: 'kraptis@uom.edu.gr',
                building: 'ΚΖ4',
                office: '401'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1503/5518-tsikPhotocrop-2.jpg',
                fname: i18n.t('eleftherios'),
                lname: i18n.t('tsikouridis'),
                title: i18n.t('epikourosKathigitis'),
                tel: '2310 891.850',
                email: 'eltsikou@uom.edu.gr',
                building: '',
                office: 'Β Υπόγειο, Πάρκινγκ'
            }
        ]
}